<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h1>My profile</h1>
        <template v-if="customer">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">
                My details
                <a
                  v-if="$root.customerVersion === 1"
                  href="#"
                  class="pull-right panel-title"
                  @click.prevent="editingCustomer = !editingCustomer"
                  v-text="editingCustomer ? 'Cancel' : 'Edit'"
                />
              </h4>
            </div>
            <div class="panel-body">
              <div
                v-if="$root.customerVersion === 2"
                class="alert alert-info"
                role="alert"
              >
                If your details need changing, please contact
                <!-- eslint-disable-next-line max-len vue/max-attributes-per-line -->
                <span class="font-weight-bold" v-text="dealerDetails.name" /> on <span class="font-weight-bold" v-text="dealerDetails.telnum" />
              </div>

              <customer-view
                :customer="customer"
                :editing="editingCustomer"
                @updated="onUpdate"
              />
            </div>
          </div>

          <div
            v-if="showContactPreferences && $root.customerVersion === 2"
            class="panel panel-primary"
          >
            <div class="panel-heading">
              <h4 class="panel-title">
                Contact preferences
                <a
                  href="#"
                  class="pull-right panel-title"
                  @click.prevent="editingContactPreferences = !editingContactPreferences"
                  v-text="editingContactPreferences ? 'Cancel' : 'Edit'"
                />
              </h4>
            </div>
            <div class="panel-body">
              <contact-preferences-form
                :customer="customer"
                :editing="editingContactPreferences"
                @updated="onUpdate"
              />
            </div>
          </div>

          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">
                Reset password
              </h4>
            </div>
            <div class="panel-body">
              <new-password-form />
            </div>
          </div>
        </template>
        <span v-else>
          <font-awesome-icon
            icon="circle-notch"
            spin
          /> Loading...
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import CustomerView from './profile/customer.vue';
import ContactPreferencesForm from './profile/contactPreferencesForm.vue';
import NewPasswordForm from './profile/newPasswordForm.vue';

export default {
  components: {
    CustomerView,
    ContactPreferencesForm,
    NewPasswordForm,
  },
  props: {
    dealerDetails: { required: true, type: Object },
  },
  data() {
    return {
      customer: null,
      editingCustomer: false,
      editingContactPreferences: false,
      showContactPreferences: false,
    };
  },
  mounted() {
    this.loadCustomer();
  },
  methods: {
    onUpdate() {
      this.loadCustomer();
      this.editingCustomer = false;
      this.editingContactPreferences = false;
    },
    loadCustomer() {
      const app = this;
      return app.ApiService.fetchCustomer(this.$root.customerId)
        .then((customer) => {
          app.customer = customer;
        })
        .catch((error) => {
          app.alertBox({ type: 'error', message: error })
            .then().catch();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
    .font-weight-bold {
        font-weight: bold;
    }
</style>
